import { render, staticRenderFns } from "./copy_email_to_clipboard.vue?vue&type=template&id=7ed445fa"
import script from "./copy_email_to_clipboard.vue?vue&type=script&lang=js"
export * from "./copy_email_to_clipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports